import { NURSE_DEPLOYMENT_FIXATION_RESOURCE } from '../api/resources';
import { createResourceSlice } from '../store/resource/createResourceSlice';

const nurseDeploymentFixationSlice = createResourceSlice({
    resource: NURSE_DEPLOYMENT_FIXATION_RESOURCE,
});

export const {
    indexFulfilled,
    showFulfilled,
    storeFulfilled,
    updateFulfilled,
    destroyFulfilled,

    indexNurseDeploymentFixations,
    showNurseDeploymentFixation,
    storeNurseDeploymentFixation,
    updateNurseDeploymentFixation,
    archiveNurseDeploymentFixation,
    restoreNurseDeploymentFixation,
    destroyNurseDeploymentFixation,
} = nurseDeploymentFixationSlice.actions;

export const {
    selectNurseDeploymentFixationById,
    makeNurseDeploymentFixationsByIdsSelector,
    selectAllNurseDeploymentFixationIds,
    selectAllNurseDeploymentFixations,
    selectNurseDeploymentFixationsLoading,
    selectNurseDeploymentFixationsInitialized,
    selectNurseDeploymentFixationLoading,
    selectNurseDeploymentFixationInitialized,
} = nurseDeploymentFixationSlice.selectors;

export const { useNurseDeploymentFixations, useLNurseDeploymentFixation } = nurseDeploymentFixationSlice.hooks;

export default nurseDeploymentFixationSlice.reducer;
